// extracted by mini-css-extract-plugin
export default {"tableList":"TableList_tableList__0Uom4","tableContent":"TableList_tableContent__U-uzx","empty":"TableList_empty__x5iJD","row":"TableList_row__GqrNJ","cell":"TableList_cell__ICmLO"};